@if (whatsNew.open()) {
  <!-- tabindex="-1" so a deliberate open can move focus here; the panel is
       non-modal on purpose, so focus is never trapped inside it. -->
  <div class="wn-panel" role="dialog" aria-labelledby="wn-title" tabindex="-1" #panel
       [class.wn-panel--wide]="!!whatsNew.featured()"
       [attr.data-theme]="whatsNew.headerTheme()">

    <!-- Curated banner: admin-picked gradient artwork + release chip. Pure
         CSS (see [data-theme] blocks in the stylesheet) — no icon here, so
         the header can never mirror an entry's glyph. -->
    <div class="wn-banner">
      <div class="wn-banner__art" aria-hidden="true">
        <span class="wn-banner__orb wn-banner__orb--a"></span>
        <span class="wn-banner__orb wn-banner__orb--b"></span>
        <span class="wn-banner__dots"></span>
      </div>
      <button type="button" class="wn-close" (click)="close()" aria-label="Close">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4">
          <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
      <div class="wn-banner__body">
        @if (whatsNew.releaseLabel()) {
          <span class="wn-banner__chip">{{ whatsNew.releaseLabel() }}</span>
        }
        <h2 class="wn-banner__title" id="wn-title">What’s New</h2>
        @if (subtitle()) {
          <span class="wn-banner__sub">{{ subtitle() }}</span>
        }
      </div>
    </div>

    <!-- Spotlight: at most one entry, admin-flagged. Artwork is optional — the
         hero keeps its emphasis and drops the image strip when there is none. -->
    @if (whatsNew.featured(); as hero) {
      <div class="wn-hero" [class.wn-hero--link]="!!hero.cta"
        [attr.role]="hero.cta ? 'button' : null"
        [attr.tabindex]="hero.cta ? 0 : null"
        [attr.aria-label]="hero.cta ? hero.title + ' — ' + hero.cta.label : null"
        (click)="hero.cta && runCta(hero)"
        (keydown.enter)="hero.cta && runCta(hero)">

        @if (hero.imageUrl && !heroImageBroken(hero.id)) {
          <div class="wn-hero__media">
            <img [src]="hero.imageUrl" alt="" loading="lazy"
                 (error)="onHeroImageError(hero.id)" />
          </div>
        }

        <div class="wn-hero__body">
          <span class="wn-hero__title">
            {{ hero.title }}
            @if (whatsNew.showingAll() && whatsNew.isUnseen(hero.id)) {
              <span class="wn-item__new">New</span>
            }
          </span>
          <p class="wn-hero__desc">{{ hero.description }}</p>
          @if (hero.cta) {
            <span class="wn-hero__cta" aria-hidden="true">
              {{ hero.cta.label }} <i class="pi pi-arrow-right"></i>
            </span>
          }
        </div>
      </div>

      @if (whatsNew.digest().length) {
        <span class="wn-divider">Also new</span>
      }
    }

    <div class="wn-list">
      @for (entry of whatsNew.digest(); track entry.id; let i = $index) {
        <div class="wn-item" [class.wn-item--link]="!!entry.cta"
          [class.wn-item--compact]="!!whatsNew.featured()"
          [style.animation-delay.ms]="40 + i * 55"
          [attr.role]="entry.cta ? 'button' : null"
          [attr.tabindex]="entry.cta ? 0 : null"
          [attr.aria-label]="entry.cta ? entry.title + ' — ' + entry.cta.label : null"
          (click)="entry.cta && runCta(entry)"
          (keydown.enter)="entry.cta && runCta(entry)">
          <span class="wn-item__icon" aria-hidden="true"><i [class]="entry.icon"></i></span>
          <div class="wn-item__text">
            <span class="wn-item__title">
              {{ entry.title }}
              @if (whatsNew.showingAll() && whatsNew.isUnseen(entry.id)) {
                <span class="wn-item__new">New</span>
              }
            </span>
            <!-- Under a spotlight the digest is a scan-list: title + date only,
                 so the hero keeps the reader's attention. -->
            @if (!whatsNew.featured()) {
              <p class="wn-item__desc">{{ entry.description }}</p>
              @if (entry.cta) {
                <span class="wn-item__cta" aria-hidden="true">
                  {{ entry.cta.label }} <i class="pi pi-arrow-right"></i>
                </span>
              }
            }
          </div>
          @if (shortDate(entry.date)) {
            <span class="wn-item__date">{{ shortDate(entry.date) }}</span>
          }
        </div>
      } @empty {
        @if (!whatsNew.featured()) {
          <div class="wn-empty">
            <i class="pi pi-check-circle" aria-hidden="true"></i>
            <p>You’re all caught up — nothing new right now.</p>
          </div>
        }
      }
    </div>

    <div class="wn-foot">
      @if (whatsNew.changelogUrl()) {
        <button type="button" class="wn-link" (click)="openChangelog()">
          View changelog <i class="pi pi-arrow-up-right"></i>
        </button>
      } @else {
        <button type="button" class="wn-link" (click)="takeTour()">
          Take the quick tour
        </button>
      }
      <button type="button" class="wn-btn" (click)="dismiss()">Got it</button>
    </div>

  </div>
}
